/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Match_Requirement_MappingInputs */

const en_deep_match_requirement_mapping = /** @type {(inputs: Deep_Match_Requirement_MappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requirement Mapping`)
};

const de_deep_match_requirement_mapping = /** @type {(inputs: Deep_Match_Requirement_MappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requirement Mapping`)
};

const fr_deep_match_requirement_mapping = /** @type {(inputs: Deep_Match_Requirement_MappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requirement Mapping`)
};

const es_deep_match_requirement_mapping = /** @type {(inputs: Deep_Match_Requirement_MappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requirement Mapping`)
};

const it_deep_match_requirement_mapping = /** @type {(inputs: Deep_Match_Requirement_MappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requirement Mapping`)
};

const nl_deep_match_requirement_mapping = /** @type {(inputs: Deep_Match_Requirement_MappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requirement Mapping`)
};

const pl_deep_match_requirement_mapping = /** @type {(inputs: Deep_Match_Requirement_MappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requirement Mapping`)
};

const fi_deep_match_requirement_mapping = /** @type {(inputs: Deep_Match_Requirement_MappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requirement Mapping`)
};

const da_deep_match_requirement_mapping = /** @type {(inputs: Deep_Match_Requirement_MappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requirement Mapping`)
};

const sv_deep_match_requirement_mapping = /** @type {(inputs: Deep_Match_Requirement_MappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requirement Mapping`)
};

/**
* | output |
* | --- |
* | "Requirement Mapping" |
*
* @param {Deep_Match_Requirement_MappingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const deep_match_requirement_mapping = /** @type {((inputs?: Deep_Match_Requirement_MappingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Match_Requirement_MappingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_deep_match_requirement_mapping(inputs)
	if (locale === "fr") return fr_deep_match_requirement_mapping(inputs)
	if (locale === "es") return es_deep_match_requirement_mapping(inputs)
	if (locale === "it") return it_deep_match_requirement_mapping(inputs)
	if (locale === "nl") return nl_deep_match_requirement_mapping(inputs)
	if (locale === "pl") return pl_deep_match_requirement_mapping(inputs)
	if (locale === "fi") return fi_deep_match_requirement_mapping(inputs)
	if (locale === "da") return da_deep_match_requirement_mapping(inputs)
	if (locale === "sv") return sv_deep_match_requirement_mapping(inputs)
	return en_deep_match_requirement_mapping(inputs)
});